function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(-10.627)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#95A1B2",
  d: "M27.88,8.626a8.629,8.629,0,0,1-12.327,7.795L12.5,18l.527-3.4A8.627,8.627,0,1,1,27.88,8.626Z"
}), /*#__PURE__*/React.createElement("g", {
  transform: "translate(17.18 2.583)"
}, /*#__PURE__*/React.createElement("circle", {
  fill: "#ffffff",
  cx: 1.518,
  cy: 1.518,
  r: 1.518,
  transform: "translate(0.556)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#ffffff",
  d: "M201.163,203.07v1.175h-4.147V203.07h.756V198.1h-.756v-1.174h3.392v6.148Z",
  transform: "translate(-197.016 -192.582)"
})));

var SvgInformation = function SvgInformation(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17.253,
    height: 18,
    viewBox: "0 0 17.253 18",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgInformation, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/information.7adf854e.svg";
export { ForwardRef as ReactComponent };